import { Backdrop, Box, Dialog, Fade, Modal } from "@mui/material";
import React from "react";
import CustomDrawer from "./CustomDrawer";
const ConfirmationDialogBox = ({
  open,
  onClose,
  onConfirm,
  message,
  children,
  confirmButtonBgColor = null,
  confirmButtonText = "Confirm",
}) => {
  return (
    <Dialog
      aria-labelledby="Category Change"
      aria-describedby="Category Change So Verify Now"
      open={open}
      onClose={onClose}
    >
      <div className="p-3">
        <div className="flex justify-end">
          <button onClick={onClose}>
            <i class="bi bi-x-lg"></i>
          </button>
        </div>
        <div className="flex justify-center">
          <svg xmlns="http://www.w3.org/2000/svg" width="36" height="33" viewBox="0 0 36 33" fill="none">
            <path
              d="M35.4338 26.4868L21.6837 2.17087C21.3105 1.51084 20.7738 0.962746 20.1275 0.58168C19.4811 0.200614 18.748 0 18.0017 0C17.2554 0 16.5223 0.200614 15.8759 0.58168C15.2296 0.962746 14.6929 1.51084 14.3197 2.17087L0.569624 26.4868C0.196317 27.1471 -0.00014434 27.8962 7.9565e-08 28.6587C0.000144499 29.4212 0.19689 30.1702 0.570447 30.8304C0.944004 31.4906 1.4812 32.0387 2.128 32.4195C2.77481 32.8004 3.50841 33.0006 4.25502 33H31.7484C32.4947 33 33.2279 32.7993 33.8742 32.4182C34.5205 32.0371 35.0573 31.489 35.4304 30.8289C35.8036 30.1688 36 29.42 36 28.6578C36 27.8956 35.8035 27.1469 35.4304 26.4868H35.4338Z"
              fill="url(#paint0_linear_23435_116103)"
            />
            <path
              d="M18.0017 22.5789C18.4473 22.581 18.8775 22.4128 19.2079 22.1075C19.5383 21.8023 19.745 21.3818 19.7874 20.9289L20.7908 10.6815C20.8265 10.3188 20.7873 9.95255 20.6757 9.60635C20.5641 9.26015 20.3827 8.94172 20.143 8.67163C19.9034 8.40153 19.611 8.18579 19.2846 8.03835C18.9582 7.8909 18.6052 7.81503 18.2483 7.81564H17.7551C17.3986 7.81564 17.046 7.89196 16.7201 8.03967C16.3943 8.18738 16.1023 8.40321 15.8632 8.67324C15.624 8.94326 15.4429 9.26149 15.3316 9.60738C15.2203 9.95328 15.1812 10.3192 15.2168 10.6815L16.2202 20.9289C16.2626 21.3811 16.4687 21.8009 16.7982 22.1061C17.1277 22.4113 17.5569 22.5799 18.0017 22.5789Z"
              fill="url(#paint1_linear_23435_116103)"
            />
            <path
              d="M18.0017 29.5263C19.6454 29.5263 20.9779 28.1655 20.9779 26.4868C20.9779 24.8081 19.6454 23.4473 18.0017 23.4473C16.358 23.4473 15.0255 24.8081 15.0255 26.4868C15.0255 28.1655 16.358 29.5263 18.0017 29.5263Z"
              fill="url(#paint2_linear_23435_116103)"
            />
            <defs>
              <linearGradient
                id="paint0_linear_23435_116103"
                x1="7.9115"
                y1="14.1864"
                x2="33.683"
                y2="31.9588"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#FED200" />
                <stop offset="1" stop-color="#F59815" />
              </linearGradient>
              <linearGradient
                id="paint1_linear_23435_116103"
                x1="-2.14282"
                y1="5.02377"
                x2="4.78249"
                y2="33.4136"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#3E4154" />
                <stop offset="1" stop-color="#1B2129" />
              </linearGradient>
              <linearGradient
                id="paint2_linear_23435_116103"
                x1="16.1132"
                y1="24.5581"
                x2="19.844"
                y2="28.2112"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#3E4154" />
                <stop offset="1" stop-color="#1B2129" />
              </linearGradient>
            </defs>
          </svg>
        </div>

        <p className="w-[314px] pt-2 text-center text-383838 text-xs font-medium capitalize">{message}</p>
        <p className="w-[314px] pt-2 text-center text-383838 text-xs font-medium capitalize">{children}</p>

        <div className="mt-4 flex justify-center gap-[10px]">
          <button
            className="bg-1d44690d text-1D4469 text-sm font-medium border border-[#EEE] rounded-[4px] w-[91px] h-[30px]"
            // onClick={() => {
            //   setCategoryChange();
            //   setLeadType("task")
            // }}
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className="text-white text-sm font-medium rounded-[7px] w-[91px] h-[30px]"
            style={{ backgroundColor: confirmButtonBgColor ?? "#1D4469" }}
          >
            {confirmButtonText}
          </button>
        </div>
      </div>
    </Dialog>
  );
};

export default ConfirmationDialogBox;
